import { Backdrop, Box, Button, CircularProgress, Dialog, IconButton, InputAdornment, Stack, TableCell, TextField, Typography, Snackbar, MenuItem } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Context } from "../App";
import { API} from "../conf";
import { Close, Delete, Edit, BadgeOutlined, Search } from "@mui/icons-material";
import Papa from 'papaparse';
import SorTableCheckable from "./sortable-checkable";
import BeneficiaireForm from "./beneficiaire-form";
import Header from "./Header";
import Import from "./import-beneficiaires";
import QRCode from 'qrcode';
import pdfMake from 'pdfmake/build/pdfmake';
import { badges, listBeneficiaires } from "../asset/pdfmaker";
import vfs from "pdfmake/build/vfs_fonts";

pdfMake.vfs = vfs;

export default function BeneficiaireRepas() {
    const input_file_ref = React.createRef()
    const {updateConnect} = useContext(Context)
    const [load, setLoad] = useState(true)
    const [imported, setImported] = useState(<Import/>)
    const [beneficiaires, setBeneficiaires] = useState([])
    const [search, setShearch] = useState('')
    const [selectItems, setItems] = useState([])
    const [beneficiaire, setBeneficiaire] = useState()
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('')
    const [open_snack, setsnack] = useState(false)
    const [snack_msg, setsnack_msg] = useState('')
    const [pdf, setPdf] = useState()

    const table = [
        {header: "Nom", sortable: true, sortBy:(el)=>el.nom.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize'}}>{row.nom}</TableCell>},
        {header: "Prénoms", sortable: true, sortBy:(el)=>el.prenoms.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize'}}>{row.prenoms}</TableCell>},
        {header: "Repas", sortable: true, sortBy:el=>el.repas.reduce((tt, item)=>tt+item.count,0), row: (row, index)=><TableCell key={index} style={{minWidth:'120px', whiteSpace:'break-spaces'}}>{row.repas.map(repas=>repas.repas+': '+repas.count).join('\n')}</TableCell>},
        {header: "", sortable: false, row: (row, index)=><TableCell key={index} align="right" sx={{minWidth:'200px'}} >
            <IconButton aria-label="badge" onClick={()=>{showBadges([row])}}><BadgeOutlined fontSize="small"/></IconButton>
            <IconButton aria-label="modifier" onClick={()=>{setBeneficiaire(row); manage_dialog(true, 'edit')}}><Edit fontSize="small"/></IconButton>
            <IconButton aria-label="supprimer" onClick={()=>{setBeneficiaire(row); manage_dialog(true, 'delete')}}><Delete fontSize="small"/></IconButton>
        </TableCell>}
    ]

    function normalize(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-.€]/gi,'').toLowerCase()
    }

    function get_searchable(item) {
        return item.nom+' '+item.prenoms
    }

    function manage_dialog(status, action) {
        setOpen(status); setAction(action)
        setImported(<Import/>)
        if (!status) {
            setBeneficiaire()
        } 
    }

    async function PDFBadgeGenerator(selecteds) {return new Promise((resolve, reject) => {
        Promise.all(selecteds.map(async(item,index) => {
            const qr = await QRCode.toDataURL(item._id)
            return{...item, qr}
        })).then((beneficiairesWithQr)=> {
            const pdfDocGenerator = pdfMake.createPdf(badges(beneficiairesWithQr));
            pdfDocGenerator.getBlob((blob) => {
                const url = URL.createObjectURL(blob);
                resolve(url)
            });
        })
    })}

    async function exportPDF(selecteds) {
        setLoad(true)
        Promise.all(selecteds.map(async(item,index) => {
            const qr = await QRCode.toDataURL(item._id)
            return{...item, qr}
        })).then((selectedsWithQr)=> {
            const pdfDocGenerator = pdfMake.createPdf(listBeneficiaires(selectedsWithQr));
            pdfDocGenerator.getBlob((blob) => {
                const url = URL.createObjectURL(blob);
                setPdf(url)
                manage_dialog(true, 'pdf')
                setLoad(false)
            });
        })
    }

    async function showBadges(selecteds) {
        setLoad(true)
        PDFBadgeGenerator(selecteds).then(pdf_url=>{
            setPdf(pdf_url)
            manage_dialog(true, 'pdf'); setLoad(false)
        }).catch(err=>{console.log(err); setLoad(false)})
    }

    function printBadges(selecteds) {
        setLoad(true)
        PDFBadgeGenerator(selecteds).then(pdf_url=>{
            const win = window.open(pdf_url, '_blank');
            if (win) {
                win.onload = () => win.print();
            } else {
                alert('Impossible d\'ouvrir le PDF et de l\'imprimer');
            }
            setLoad(false)
        })
    }

    async function handleDelete(ids) {
        setLoad(true)
        fetch(API.concat(`/BeneficiaireRepas/by/${JSON.stringify({_id:{$in:ids}})}`), {method:'DELETE', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', token)
                }
                if (response.status === 204) {
                    setBeneficiaires(old=> old.filter(usr=>!ids.includes(usr._id)))
                    manage_dialog(false, '')
                } setLoad(false)
            }
        })
    }

    function handleImport(event) {
        event.preventDefault();
        setLoad(true)

        let userFile = event.target.files[0];

        Papa.parse(userFile, {
            header: true,
            complete: function(results) {
                let imported = results.data
                let headers = Object.keys(imported[0])
                setLoad(false)
                manage_dialog(true, 'import')

                if (headers && headers.every(header => ['nom', 'prenoms'].includes(header))) {
                    setImported(<Import users={imported} updateData={setBeneficiaires} old={beneficiaires} close={()=>manage_dialog(false, '')} />)
                } else {
                    setImported(<Import msg='Entêtes invalides!' close={()=>manage_dialog(true, 'import')}/>);
                }
            }
        })
    }

    useEffect(()=>{
        fetch(API.concat('/BeneficiaireRepas/all'), {method:'GET', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }}).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    setBeneficiaires(json); setLoad(false)
                }else setLoad(false)
            }
        })
    },[updateConnect]) 

    return(
        <Box display='flex' flex={1} flexDirection='column' marginBottom='30px'>
            <Header/>
            <Typography variant="h4" align="center" marginY={5}>Gestion des bénéficiares de repas</Typography>
            <Stack direction='row' spacing={2} alignSelf='end' alignItems='center' marginX='30px' marginBottom={2}>
                <Button variant="contained" disabled={selectItems.length<1} onClick={()=>exportPDF(beneficiaires.filter(dlg=>selectItems.includes(dlg._id)))}>Export pdf</Button>
                <Button variant="contained" disabled={selectItems.length<1} onClick={()=>showBadges(beneficiaires.filter(dlg=>selectItems.includes(dlg._id)))}>badges</Button>
            </Stack>
            <Box display='flex' justifyContent='space-between' alignItems='center' marginX='30px'>
                <TextField placeholder="Rechercher un bénéficiaires" size="small" sx={{width:'60%', minWidth:'400px'}} value={search} onChange={e=>setShearch(e.target.value)}
                slotProps={{input:{endAdornment: (<InputAdornment position="end"><Search /></InputAdornment>)}}}/>
                <Stack direction='row' spacing={1} alignItems='center'>
                    <input type='file' name='beneficiaires_file' accept='.csv' ref={input_file_ref} hidden onChange={(event)=>{handleImport(event)}} />
                    <Button variant="contained" onClick={()=> input_file_ref.current.click()}>Importer</Button>
                    <Button variant="contained" onClick={()=>manage_dialog(true, 'add')}>Ajouter</Button>
                    <Button variant="contained" disabled={selectItems.length<1} onClick={()=>manage_dialog(true, 'delete many')}>supprimer</Button>
                </Stack>
            </Box>

            <div style={{marginInline:'30px'}}><SorTableCheckable data={beneficiaires.filter(item=> normalize(get_searchable(item)).includes(normalize(search)))} selectItems={selectItems} setItems={setItems} table={table} rowsPerPage={100} rowsPerPageOptions={[50, 100, 300]}/></div>

            <Snackbar
            open={open_snack}
            autoHideDuration={5000}
            onClose={()=> setsnack(false)}
            message={snack_msg}
            />

            <Backdrop open={load}><CircularProgress/></Backdrop>
            <Dialog open={open} fullWidth maxWidth={action==='import'?'lg':['add', 'edit', 'pdf'].includes(action)?'md':'xs'} onClose={()=>manage_dialog(false, '')}>
                <IconButton onClick={()=>manage_dialog(false, '')} sx={{alignSelf:'end', marginTop:'5px', marginRight:'5px'}}><Close/></IconButton>
                {action==='add'&& <BeneficiaireForm {...{add:usr=>setBeneficiaires(old=>[...old, usr]), close:()=>manage_dialog(false, '')}} />}
                {action==='import'&& imported}
                {action==='edit'&&beneficiaire&& <BeneficiaireForm {...{edit:true, beneficiaire, add:usr=>setBeneficiaires(old=>[...old.filter(u=>u._id!==usr._id), usr]), close:()=>manage_dialog(false, '')}} />}
                {action==='pdf' && pdf &&<Box sx={{marginInline:2}}><embed src={pdf} width='100%' height='600px' type="application/pdf" /></Box>}
                {action==='delete'&&<Box display='flex' flexDirection='column' paddingInline={1} paddingBottom={1}>
                    <Typography fontWeight={600} fontSize={18} align="center" textTransform='capitalize'>Supprimer {[beneficiaire.nom, beneficiaire.prenoms].join(' ')}</Typography>
                    <Stack direction='row' spacing={2} marginTop={2} alignItems='center' alignSelf='end'>
                        <Button variant="outlined"  onClick={()=>manage_dialog(false,'')}>annuler</Button>
                        <Button variant="contained" color="carmine" onClick={()=>handleDelete([beneficiaire._id])}>supprimer</Button>
                    </Stack>
                </Box>}
                {action==='delete many'&&<Box display='flex' flexDirection='column' paddingInline={1} paddingBottom={1}>
                    <Typography fontWeight={600} fontSize={18} align="center">Supprimer {selectItems.length} bénéficiare{selectItems.length>1&&'s'} de repas</Typography>
                    <Stack direction='row' spacing={2} marginTop={2} alignItems='center' alignSelf='end'>
                        <Button variant="outlined"  onClick={()=>manage_dialog(false,'')}>annuler</Button>
                        <Button variant="contained" color="carmine" onClick={()=>handleDelete(selectItems)}>supprimer</Button>
                    </Stack>
                </Box>}
            </Dialog>
        </Box>
    )
}